import React from 'react';
import './PlaceNameLayer.css';

const PlaceNameLayer = ({ currentLocation }) => {
  return (
    <p id="place-name">
      <span>{currentLocation.city}</span>
      <span>{currentLocation.name}</span>
    </p>
  );
};

export default PlaceNameLayer;
